/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { Dialog, CardContent, Card, IconButton } from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import { useSnackbar } from "hooks/useSnackbar";
import WebpageEditContext from "components/webpage-selector/context";
import GalleryContext from "components/webpage-selector/gallery/context";
import WebpageDialogTopActions from "components/webpage-selector/dialog/actions/dialog-top-actions";
import { WebpageDialogBottomActions } from "components/webpage-selector/dialog/actions/dialog-bottom-actions";
import { WebpageDialogPreviewPanel } from "components/webpage-selector/dialog/panels/dialog-preview-panel";
import { WebpageDialogGalleryPanel } from "components/webpage-selector/dialog/panels/dialog-gallery-panel";

const WebpageSelectDialog = (props) => {

    const { showSnackbar } = useSnackbar();
    const searchFunction = SimpliCityAdminSDK.webpage.search;
    const scrollableHeight = "480px"; // '450px'
    const filter = props.filter;
    const filterValue = props.filterValue;

    const ctx = useContext(WebpageEditContext);
    const {
        open,
        handleClose,
        selectedWebpage,
        setSelectedWebpage,
        webpages,
        setWebpages
    } = ctx;

    const onSelectWebpage = (event, webpage) => {
        showSnackbar("onSelectWebpage");
        event.stopPropagation();
        setSelectedWebpage(webpage);
    };

    const galleryCTX = {
        webpages,
        setWebpages,
        searchFunction,
        scrollableHeight,
        onSelectWebpage,
        selectedWebpage, // from edit context
        setSelectedWebpage, // from edit context
        showSnackbar,
        filter,
        filterValue
    };

    return (
        <Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth='lg'
                className='simplicity-image-selector-overlay'
            >
                <GalleryContext.Provider value={galleryCTX}>
                    <Card elevation={0} className='simplicity-webpage-selector-window'>
                        <CardContent sx={{ flex: "1 0 auto", height: "100%" }}>
                            <div className='simplicity-image-selector-window-title'>
                                Webpage Selector
                                <IconButton onClick={handleClose} style={{ marginLeft: "auto" }}>
                                    <CloseOutlined />
                                </IconButton>
                            </div>

                            <WebpageDialogTopActions />

                            <div className='simplicity-image-selector-window-content'>
                                <div className='simplicity-image-selector-window-active'>
                                    <>
                                        <WebpageDialogGalleryPanel />
                                        <WebpageDialogPreviewPanel />
                                    </>
                                </div>
                            </div>
                        </CardContent>
                    </Card>

                    <WebpageDialogBottomActions />
                </GalleryContext.Provider>
            </Dialog>
        </Fragment>
    );
};

export { WebpageSelectDialog };
